import { object, string } from 'yup'

export const contactAgentEmailModalFormValidation = object({
  message: string().optional(),
})
